var map = {
	"./chrome_plugin.png": 8890,
	"./mac_icon.png": 80783,
	"./plugin_mac_cn.png": 75453,
	"./plugin_mac_en.png": 5079,
	"./plugin_windows_cn.png": 87031,
	"./plugin_windows_en.png": 96829,
	"./recommend.png": 91760,
	"./select_mac_icon.png": 59746,
	"./select_windows_icon.png": 16056,
	"./windows_icon.png": 49957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46827;